import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/app/assignation`;

const Assignation = {
  async getAssignableUsers(contactId) {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/${contactId}/assignable-users/`;
    return request(url, options);
  },
  async assignUserToContact({ contactId, userId }) {
    const options = await requestOptions("POST", { userId, contactId }, true);
    const url = `${baseUrl}/${contactId}/assign-user`;
    return request(url, options);
  },
  async unassignUserToContact({ contactId, userId }) {
    const options = await requestOptions("POST", { userId, contactId }, true);
    const url = `${baseUrl}/${contactId}/unassign-user`;
    return request(url, options);
  },
  async getListOfUsers() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/users/`;
    return request(url, options);
  },
};

export default Assignation;
